import { useVuexState } from '@scfe-common/micro-frontend-utils';
import { useMemo } from 'react';

import { useWorkforceEnums } from '@/store/workforce-enums';

import { WorkstationActivityType } from '../type';

const transformToOptions = (obj: Record<string, any>) => {
  return Object.keys(obj).map((key) => {
    return {
      value: obj[key],
      label: key,
    };
  });
};

export const useActivityTypeOptions = (dataSource: WorkstationActivityType[]) => {
  const enums = useWorkforceEnums.use.enums();
  const activityTypesEnum = enums.workstation_type;
  const optionsConfig = useMemo(() => {
    const activityTypes = transformToOptions(activityTypesEnum || {});
    const activityTypeSet = new Set();
    const sequenceSet = new Set();
    dataSource.forEach((val) => {
      activityTypeSet.add(val.activity_type);
      sequenceSet.add(val.sequence);
    });
    const activityTypeOptions = activityTypes.map((activityTypeOption: any) => {
      return { ...activityTypeOption, disabled: activityTypeSet.has(activityTypeOption.value) };
    });
    const sequenceOptions = activityTypes.map((activityTypeOption: unknown, index: number) => {
      const val = index + 1;
      return { label: val.toString(), value: val, disabled: sequenceSet.has(val) };
    });
    return {
      activityTypeOptions,
      sequenceOptions,
    };
  }, [activityTypesEnum, dataSource]);
  return optionsConfig;
};
